import SearchFilter from './SearchFilter';

const initSidebarWidget = () => {
  const sidebarWidgets = document.querySelectorAll('.sidebar-widget');

  if (null === sidebarWidgets) {
    return;
  }

  function SidebarWidget(widget: HTMLElement) {
    const search = widget.querySelector('.sidebar-filters .sidebar-search');
    const showMore = widget.querySelector('.show-aggregation-values') as HTMLElement;
    const collapsedFilters = widget.querySelector('.filters.collapse');

    const expandAggregationValues = function () {
      const commentSpan = widget.querySelector('.moreAggregationValues');

      if (commentSpan) {
        collapsedFilters.insertAdjacentHTML('afterbegin', commentSpan.innerHTML.slice(4, -4));
        commentSpan.remove();
      }

      return widget.querySelectorAll('ul.filters li');
    };

    let filtersList = null;
    const filter = new SearchFilter({
      items: filtersList,
    });

    if (search) {
      widget.querySelector('.search').addEventListener('input', function () {
        const searchValue = this.value;
        filtersList = expandAggregationValues();

        filter.setItems(filtersList);
        filter.filter(searchValue);

        if (searchValue.length > 0) {
          collapsedFilters.classList.add('show');

          if (showMore) {
            showMore.style.visibility = 'hidden';
          }
        } else {
          collapsedFilters.classList.remove('show');

          if (showMore) {
            showMore.setAttribute('aria-expanded', 'false');
            showMore.style.visibility = 'visible';
          }
        }
      });
    }

    /*
     * Load missing property values (> 10 items) from HTML comment block
     * and append them to the DOM. HTML is pregenerated on
     * the server side rather than via javascript for speeding up
     * the process with older javascript implementation
     */
    if (showMore) {
      showMore.addEventListener('click', function (e) {
        e.preventDefault();
        filtersList = expandAggregationValues();

        if (filter !== null) {
          filter.setItems(filtersList);
        }
      });
    }
  }

  [].forEach.call(sidebarWidgets, function (widget) {
    SidebarWidget(widget);
  });
};

export default initSidebarWidget;
